import { useContext } from 'react';
import { NextPage } from 'next';

import { selectCmsPageSection } from 'utils/locale';

import LocaleContext from 'components/context/Locale';
import Head from 'components/layout/Head';
import PageContainer from 'components/layout/PageContainer';
import LayoutDefault from 'components/modules/public/layouts/Default';

import ContactSection from './sections/Contact';
import CooperationSection from './sections/Cooperation';
import HeroSection from './sections/Hero';
import HeroDescriptionSection from './sections/HeroDescription';
import InfoSection from './sections/Info';
import InstructionsSection from './sections/Instructions';
import MissionSection from './sections/Mission';
import StyledComponent from './styles';
import { Props } from './types';

const PublicPageAbout: NextPage<Props> = ({ cmsPage }) => {
    const localeContext = useContext(LocaleContext);
    const data = localeContext?.translations?.about;

    return (
        <StyledComponent className="public-page-about">
            <Head
                {...data.meta}
                title={cmsPage?.metaTitle || data?.meta?.title}
                description={cmsPage?.metaDescription || data?.meta?.description}
                robots={cmsPage?.metaRobots}
                image={cmsPage?.image?.imageUrl || data?.meta?.image}
            />
            <LayoutDefault>
                <PageContainer>
                    <HeroSection
                        translations={{
                            ...data.content.hero,
                            ...selectCmsPageSection(cmsPage, 'hero'),
                        }}
                    />
                    <HeroDescriptionSection
                        translations={{
                            ...data.content.hero,
                            ...selectCmsPageSection(cmsPage, 'hero'),
                        }}
                    />
                    <InfoSection
                        translations={{
                            ...data.content.info,
                            ...selectCmsPageSection(cmsPage, 'info'),
                        }}
                    />
                    <InstructionsSection
                        translations={{
                            ...data.content.instructions,
                            ...selectCmsPageSection(cmsPage, 'instructions'),
                        }}
                    />
                    <CooperationSection
                        translations={{
                            ...data.content.cooperation,
                            ...selectCmsPageSection(cmsPage, 'cooperation'),
                        }}
                    />
                    <MissionSection
                        translations={{
                            ...data.content.mission,
                            ...selectCmsPageSection(cmsPage, 'mission'),
                        }}
                    />
                    <ContactSection
                        translations={{
                            ...data.content.contact,
                            ...selectCmsPageSection(cmsPage, 'contact'),
                        }}
                    />
                </PageContainer>
            </LayoutDefault>
        </StyledComponent>
    );
};

export default PublicPageAbout;
